(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4405],{

/***/ 446:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[...all]",
      function () {
        return __webpack_require__(70895);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24987);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60306);
/* harmony import */ var _components_DestinationPage_DestinationPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20655);





function Destination(param) {
    var country = param.country, city = param.city, isHotelsPage = param.isHotelsPage, destination = param.destination;
    var destinationObj = {
        country: country,
        city: city
    };
    var title = "Hotels in ".concat(destination.city !== "-" ? destination.city : "").concat(destination.city !== "-" ? "," : "", " ").concat(destination.country);
    return isHotelsPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .HotelReviewsList */ .Wj, {
        type: "destination",
        listTitle: title,
        country: destinationObj.country,
        city: destinationObj.city
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DestinationPage_DestinationPage__WEBPACK_IMPORTED_MODULE_4__/* .DestinationPage */ .S, {
            data: {
                destination: destination,
                country: country,
                city: city
            }
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__/* .withLayout */ .X)(Destination, true));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,2478,9774,2888,179], function() { return __webpack_exec__(446); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);